// @flow

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import history from 'client/utils/history';
import Navbar from 'client/components/Navbar';
import Loading from 'client/components/Loading';
import { getToken } from 'client/utils/user';
import Styles from './styles';
import { getLoginCode, checkUserLoggedin, clearLogin } from './redux';

type Props = {
  loginCode : any,
  getLoginCodeLoading : boolean,
  getLoginCode : (refrenceRoute : string) => void,
  clearLogin : () => void,
  location : any,
};

const Search = ({
  getLoginCode: getLoginCodeAction,
  clearLogin: clearLoginAction,
  getLoginCodeLoading,
  location,
  loginCode,
} : Props) => {
  useEffect(() => {
    if (getToken()) {
      history.push('/');
    } else {
      getLoginCodeAction();
    }
    return (() => {
      clearLoginAction();
    });
  }, []);

  return (
    <Styles className="rtl">
      {!getToken() && <Navbar backRoute={_.get(location, ['state', 'backRoute'])} />}
      {
        (getLoginCodeLoading || getToken()) &&
        <Loading />
      }
      {
        (loginCode && loginCode.size > 0 && !getLoginCodeLoading && !getToken()) &&
        <div className="contentWrapper">
          <div className="qrWrapper">
            <img src={loginCode.get('qrURL')} alt="qrcode" />
          </div>
          <div className="urlWrapper">
            <h1 className="title">اتصال آپارات به تلویزیون</h1>
            <p className="description">برای تماشای  روی تلویزیون, با استفاده از مرورگر موبایل یا رایانه شخصی خود به آدرس زیر مراجعه کنید:</p>
            <p className="description">
              <span className="highligt">https://aparat.com/activate</span>
            </p>
            <p className="description">
            یا QR کد سمت راست همین صفحه را اسکن کنید و کد
              <span className="highligt code">{loginCode.get('code')}</span>
              را برای فعال سازی وارد کنید.
            </p>
          </div>
        </div>
      }
      {/* eslint-disable-next-line */}
      <span className="version">نسخه: {_.get(process.env.APP_CONFIG, ['APP_GLOBAL_CONFIG', 'APP_VERSION'], '')}</span>
    </Styles>
  );
};

export default connect(
  (state : any) => ({
    getLoginCodeLoading: state.getIn(['Login', 'getLoginCodeLoading']),
    loginCode: state.getIn(['Login', 'loginCode']),
    checkUserLoggedinLoading: state.getIn(['Login', 'checkUserLoggedinLoading']),
  }),
  {
    getLoginCode,
    checkUserLoggedin,
    clearLogin,
  },
)(Search);
